import initModal from './initializers/Modal.js'
import initUser from './initializers/User.js'
import initRegistration from './initializers/Registration.js'
import initWelcomeMessageSidebar from './initializers/WelcomeMessageSidebar.js'

const initApplication = () => {
  initModal()
  initUser()
  initRegistration()
  initWelcomeMessageSidebar()
}

export default initApplication
